import { CLOSE_CONTEXT_MENU, OPEN_CONTEXT_MENU } from '../actions/ContextMenu';
const initialState = {
    open: false,
    options: [],
    xOffset: 0,
    yOffset: 0,
    refinement: false,
    header: "",
    label: "",
    showSignInButton: false,
    hover: false
};
const reducer = {
    [OPEN_CONTEXT_MENU]: (state, action) => {
        var _a;
        return Object.assign(Object.assign(Object.assign({}, state), action.payload), { open: true, hover: ((_a = action.payload) === null || _a === void 0 ? void 0 : _a.hover) === true });
    },
    [CLOSE_CONTEXT_MENU]: (state, action) => {
        return Object.assign(Object.assign({}, state), { open: false });
    },
};
export function ContextMenuReducer(state = initialState, action) {
    if (reducer[action.type]) {
        return reducer[action.type](state, action);
    }
    else {
        return state;
    }
}
